import { Box, IconButton, SvgIcon } from '@material-ui/core';
import ChatMessageQuoted from '@src/components/ChatTimeline/ChatMessage/ChatMessageQuoted';
import { removeQuotedMessage } from '@src/reducers/chats';
import {
  activeChatSelector,
  activeQuotedMessageSelector,
} from '@src/selectors/chats';
import { ChatTray } from '@src/types/chats';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CloseIcon } from './SvgIcons';

const ChatQuotedMessagePreview: React.FC = () => {
  const dispatch = useDispatch();
  const activeChat = useSelector(activeChatSelector);
  const { contact } = useSelector(activeChatSelector) as ChatTray;

  const activeQuotedMessage = useSelector(activeQuotedMessageSelector);

  if (!activeQuotedMessage) return null;

  return (
    <Box display="flex" alignItems="center" width="100%">
      <Box style={{ maxHeight: 300, overflow: 'auto' }}>
        <ChatMessageQuoted
          quotedMessage={activeQuotedMessage}
          contact={contact}
        />
      </Box>
      <IconButton
        style={{ marginLeft: 5, padding: 8 }}
        onClick={() => dispatch(removeQuotedMessage(activeChat.id))}
      >
        <SvgIcon fontSize="small">{CloseIcon}</SvgIcon>
      </IconButton>
    </Box>
  );
};

export default ChatQuotedMessagePreview;
